<template>
  <div class="formula-block">
    <div class="formula-block__body">
      <div class="formula-block__head">
        <code class="formula-block__name">{{ name }}</code>
        <span class="formula-block__equals">=</span>
        <code class="formula-block__formula">{{ formula }}</code>
      </div>
      <div v-if="$slots.condition" class="formula-block__condition">
        <CIcon name="cipInfo" size="sm" class="mr-1"/>
        <slot name="condition"/>
      </div>
    </div>
    <div v-if="!noEntry && produces.length" class="formula-block__outputs">
      <div
        v-for="(out, idx) in produces"
        :key="idx"
        class="formula-output"
      >
        <span class="formula-output__arrow">→</span>
        <span v-if="out.negative" class="formula-output__sign">(−)</span>
        <CBadge :color="stakeholderColor(out.stakeholder)" class="formula-output__stakeholder mr-1">
          {{ stakeholderLabel(out.stakeholder) }}
        </CBadge>
        <span class="formula-output__entry">{{ out.entryType }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import {getStakeholderColor} from '../../constants'

const STAKEHOLDER_LABELS = {
  pica: 'Pica',
  photographer: 'Photographer',
  organizer: 'Organizer',
  agent: 'Agent'
}

export default {
  name: 'FormulaBlock',
  props: {
    name: {type: String, required: true},
    formula: {type: String, required: true},
    produces: {type: Array, default: () => []},
    noEntry: {type: Boolean, default: false}
  },
  methods: {
    stakeholderLabel(key) {
      return STAKEHOLDER_LABELS[key] || key
    },
    stakeholderColor(key) {
      return getStakeholderColor(key)
    }
  }
}
</script>

<style scoped>
.formula-block {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  background: #fff;
  border: 1px solid #e4e7ea;
  border-radius: 6px;
  margin-bottom: 8px;
}

.formula-block__body {
  flex: 1 1 60%;
  min-width: 0;
}

.formula-block__head {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}

.formula-block__name {
  background: #100F23;
  color: #fff;
  padding: 2px 8px;
  border-radius: 3px;
  font-size: 0.85rem;
  font-weight: 600;
}

.formula-block__equals {
  color: #6c7285;
  font-weight: 600;
}

.formula-block__formula {
  background: #f4f6f9;
  padding: 3px 8px;
  border-radius: 3px;
  font-size: 0.82rem;
  color: #2c2f3a;
  border: 1px solid #e4e7ea;
}

.formula-block__condition {
  margin-top: 6px;
  color: #6c7285;
  font-size: 0.78rem;
  font-style: italic;
  display: flex;
  align-items: flex-start;
}

.formula-block__outputs {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 0 0 auto;
}

.formula-output {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 0.85rem;
}

.formula-output__arrow {
  color: #6c7285;
  font-weight: 700;
  font-size: 1rem;
}

.formula-output__sign {
  color: #d9534f;
  font-weight: 700;
  background: #fdecea;
  padding: 0 4px;
  border-radius: 3px;
  font-size: 0.78rem;
}

.formula-output__entry {
  font-family: monospace;
  font-size: 0.75rem;
  letter-spacing: 0.3px;
  background: #fff;
  border: 1px solid #d8dbe0;
  color: #2c2f3a;
  padding: 2px 8px;
  border-radius: 3px;
}
</style>
